import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'
import round from 'lodash/round'

import { observer } from 'mobx-react'

import * as stylesRefs from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/index.vanilla.css'
import type {
  Column,
  ColumnsType,
} from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import {
  dailyGridTemplateColumns,
  gridColumn,
} from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import type { View } from 'modules/shift_management/lib/types'
import type Coverages from 'modules/shift_management/store/internal/collections/Coverages'

export interface Props {
  view: View
  coverages: Coverages
  columns: ColumnsType
}

interface EmployeesByHour {
  column: Column
  count: number
}

const EmployeesByHourGrid = ({ view, coverages, columns }: Props) => {
  const { dates } = view
  const cx = useClassNames(stylesRefs)
  const hoursToAdd = columns.length - dates.length

  const employeesByHourCount: EmployeesByHour[] = columns.flatMap((column: Column) => {
    const numberOfShifts = coverages.getNumberOfShifts(column.date)
    return { column, count: round(numberOfShifts, 2) }
  })

  return (
    <>
      <Box className={cx('grid')} style={{ ...dailyGridTemplateColumns(view, hoursToAdd) }}>
        {employeesByHourCount.map((employeesByHour: EmployeesByHour, columnIndex: number) => {
          const { column, count } = employeesByHour
          const { hour } = column

          return (
            <Box
              key={columnIndex}
              flexDirection="row"
              height="full"
              paddingX="s4"
              alignItems="center"
              border={{
                right: {
                  width: 's1',
                  style: 'solid',
                  color: 'grey400',
                },
              }}
              style={{ ...gridColumn(hour, hour + 1), minWidth: column.minWidth }}
            >
              <Box flexDirection="row" alignItems="center" overflowX="hidden">
                <Text size="100" color={count > 0 ? 'grey800' : 'grey600'}>
                  {count}
                </Text>
              </Box>
            </Box>
          )
        })}
      </Box>
    </>
  )
}

export default observer(EmployeesByHourGrid)
